interface CardOfWeekSectionProps {
  card: {
    type: string;
    cardName: string;
    cardImage: string | null;
    message: string;
    sendDate: string;
  };
}

export default function CardOfWeekSection({ card }: CardOfWeekSectionProps) {
  const formattedDate = new Date(card.sendDate).toLocaleDateString('pt-PT', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });

  const cardTypeLabel = card.type === 'weekend' ? 'Carta do fim de semana' : 'Carta da semana';

  return (
    <section id="carta-semana" className="py-[60px] bg-[radial-gradient(circle_at_top,rgba(139,92,246,0.10),#020617_60%)] border-t border-b border-[#111827]">
      <div className="max-w-[1120px] mx-auto px-4">
        <div className="mb-6">
          <p className="text-[0.8rem] uppercase tracking-[0.08em] text-[#a5b4fc]">{cardTypeLabel}</p>
          <h2 className="text-[1.8rem] font-bold text-[#e5e7eb] mt-1">{card.cardName}</h2>
          <p className="text-[0.82rem] text-[#94a3b8] mt-1">Ativa desde {formattedDate}</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-[340px_minmax(0,1fr)] gap-6 items-start">
          <div className="rounded-2xl border border-[#1f2937] bg-[#0b1220] p-3 shadow-[0_18px_40px_rgba(0,0,0,0.35)]">
            {card.cardImage ? (
              <img
                src={card.cardImage}
                alt={card.cardName}
                className="w-full aspect-[4/5] rounded-xl object-cover"
                loading="lazy"
              />
            ) : (
              <div className="w-full aspect-[4/5] rounded-xl bg-[#111827] border border-[#1f2937] flex items-center justify-center text-[#94a3b8] text-sm">
                Sem imagem disponível
              </div>
            )}
          </div>

          <article className="rounded-2xl border border-[#1f2937] bg-[#0b1220] p-6 shadow-[0_18px_40px_rgba(0,0,0,0.35)]">
            <h3 className="text-lg font-semibold text-[#e5e7eb] mb-3">Mensagem da carta</h3>
            <p className="text-[#cbd5f5] whitespace-pre-wrap leading-relaxed">{card.message}</p>
          </article>
        </div>
      </div>
    </section>
  );
}
